module.exports = __webpack_public_path__ + "static/img/15.e7a908e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/zh/15.png
// module id = 53fX
// module chunks = 0